import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import LandingPageView from "@/views/LandingPageView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: LandingPageView,
  },
  {
    path: "/write",
    name: "write",
    component: () =>
      import(/* webpackChunkName: "write" */ "../views/WriteView.vue"),
  },
  {
    path: "/label",
    name: "label",
    component: () =>
      import(/* webpackChunkName: "label" */ "../views/LabelView.vue"),
  },
  {
    path: "/upload",
    name: "upload",
    component: () =>
      import(/* webpackChunkName: "upload" */ "../views/UploadView.vue"),
  },
  {
    path: "/download",
    name: "download",
    component: () =>
      import(/* webpackChunkName: "download" */ "../views/DownloadView.vue"),
  },
  {
    path: "/verify",
    name: "verify",
    component: () =>
      import(/* webpackChunkName: "verify" */ "../views/VerifyView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
